import React from 'react';
import VehicleDetails from './VehicleDetails.jsx';
import { observer } from 'mobx-react-lite';
import { useStores } from '@stores/context.jsx';
import { useNavigate, useLocation } from 'react-router-dom';
import DetailsSideBar from '@common/DetailsSideBar/DetailsSideBar.jsx';
import { EBlurEffectStates } from '@common/DetailsSideBar/DetailsSideBar.constants.js';
import { useTranslation } from 'react-i18next';

const VehicleDetailSidebar = observer((props) => {
    const { serviceStore, assetStore } = useStores();
    const { vehicleId } = props;
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const close = async () => {
        navigate(`${serviceStore.currentService}/vehicles${location.search}`);
    };
    return (
        <DetailsSideBar
            title={`${t("fotaone.general.vehicleData.vehicleDetails")}`}
            onClose={close}
            width={600}
            blurEffect={assetStore.detailsState.isLoading === true ? EBlurEffectStates.Show : EBlurEffectStates.Hide}
            fly
        >
            <VehicleDetails vehicleId={vehicleId} />
        </DetailsSideBar>
    );
});

export default VehicleDetailSidebar;
